export type Role = {
  id_funcao: number;
  nm_funcao: string;
};

// eslint-disable-next-line no-shadow
export enum RoleEnum {
  ADMIN = 1,
  GERENTE_CONTAS = 5,
  OPERACIONAL = 3,
  SUPORTE = 4,
  CLIENTE = 6,
  PARCEIRO_COMERCIAL = 2,
}
